import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

// Short tracked link: /ref/:code → forwards to /get-started with ref param + utm.
// LeadForm reads these from the query string and stamps the lead's referred_by.
export default function ReferralRedirect() {
    const { code } = useParams();
    useEffect(() => {
        try {
            window.localStorage.setItem("ps_ref", code || "");
        } catch (_) {}
    }, [code]);
    if (!code) return <Navigate to="/get-started" replace />;
    const params = new URLSearchParams({
        ref: code,
        utm_source: "referral",
        utm_medium: "sms",
        utm_campaign: code,
    });
    return <Navigate to={`/get-started?${params.toString()}`} replace />;
}
